<!-- FeOptionsSelect — componente dumb prop-based (primo della directory ui/)
     Contratto: il chiamante passa options[] con label già tradotte.
     Nessun accesso a store, CDN, API o I18n — logica di presentazione pura.
     Pattern: dumb component (opzioni via props) vs FeCashierSelect (smart, fetcha internamente) -->
<script setup lang="ts">
import { computed } from 'vue'
import { IonInput } from '@ionic/vue'
import type { SelectOption } from './types'

defineOptions({ name: 'FeOptionsSelect' })

const props = withDefaults(
  defineProps<{
    modelValue: string
    options: SelectOption[]
    readonlyWhenSingle?: boolean
    dataTest?: string
  }>(),
  { readonlyWhenSingle: false, dataTest: undefined },
)

const emit = defineEmits<{ 'update:modelValue': [string] }>()

const internalValue = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
})

const selectedLabel = computed(
  () => props.options.find((o) => o.value === props.modelValue)?.label ?? '',
)

// Mostra readonly se abilitato e c'è al più una opzione disponibile
const isReadonly = computed(
  () => props.readonlyWhenSingle && props.options.length <= 1,
)
</script>

<template>
  <div v-if="isReadonly" class="abs-input-wrapper">
    <ion-input
      :value="options[0]?.label ?? ''"
      label-placement="floating"
      :readonly="true"
    />
  </div>
  <fe-select
    v-else
    v-model="internalValue"
    :data-test="dataTest"
    :selected-option-label="selectedLabel"
  >
    <fe-select-option
      v-for="opt in options"
      :key="opt.value"
      :value="opt.value"
    >
      {{ opt.label }}
    </fe-select-option>
  </fe-select>
</template>
